export default [
  { ISO2: "DE", internalCode: 36, label: "Deutschland" },
  { ISO2: "AF", internalCode: 1, label: "Afghanistan" },
  { ISO2: "EG", internalCode: 2, label: "Ägypten" },
  { ISO2: "AL", internalCode: 3, label: "Albanien" },
  { ISO2: "DZ", internalCode: 4, label: "Algerien" },
  { ISO2: "AD", internalCode: 5, label: "Andorra" },
  { ISO2: "AO", internalCode: 6, label: "Angola" },
  { ISO2: "AG", internalCode: 7, label: "Antigua und Barbuda" },
  { ISO2: "GQ", internalCode: 8, label: "Äquatorialguinea" },
  { ISO2: "AG", internalCode: 9, label: "Argentinien" },
  { ISO2: "AM", internalCode: 10, label: "Armenien" },
  { ISO2: "AZ", internalCode: 11, label: "Aserbaidschan" },
  { ISO2: "ET", internalCode: 12, label: "Äthiopien" },
  { ISO2: "AU", internalCode: 13, label: "Australien" },
  { ISO2: "BS", internalCode: 14, label: "Bahamas" },
  { ISO2: "BH", internalCode: 15, label: "Bahrain" },
  { ISO2: "BD", internalCode: 16, label: "Bangladesch" },
  { ISO2: "BB", internalCode: 17, label: "Barbados" },
  { ISO2: "BY", internalCode: 18, label: "Belarus" },
  { ISO2: "BE", internalCode: 19, label: "Belgien" },
  { ISO2: "BZ", internalCode: 20, label: "Belize" },
  { ISO2: "BJ", internalCode: 21, label: "Benin" },
  { ISO2: "BT", internalCode: 22, label: "Bhutan" },
  { ISO2: "BO", internalCode: 23, label: "Bolivien" },
  { ISO2: "BA", internalCode: 24, label: "Bosnien und Herzegowina" },
  { ISO2: "BW", internalCode: 25, label: "Botsuana" },
  { ISO2: "BR", internalCode: 26, label: "Brasilien" },
  { ISO2: "BN", internalCode: 27, label: "Brunei" },
  { ISO2: "BG", internalCode: 28, label: "Bulgarien" },
  { ISO2: "BF", internalCode: 29, label: "Burkina Faso" },
  { ISO2: "BI", internalCode: 30, label: "Burundi" },
  { ISO2: "CL", internalCode: 31, label: "Chile" },
  { ISO2: "CN", internalCode: 32, label: "China" },
  { ISO2: "CK", internalCode: 33, label: "Cook-Inseln" },
  { ISO2: "CR", internalCode: 34, label: "Costa Rica" },
  { ISO2: "DK", internalCode: 35, label: "Dänemark" },
  { ISO2: "DM", internalCode: 37, label: "Dominica" },
  { ISO2: "DO", internalCode: 38, label: "Dominikanische Republik" },
  { ISO2: "DJ", internalCode: 39, label: "Dschibuti" },
  { ISO2: "EC", internalCode: 40, label: "Ecuador" },
  { ISO2: "SV", internalCode: 41, label: "El Salvador" },
  { ISO2: "CI", internalCode: 42, label: "Elfenbeinküste" },
  { ISO2: "ER", internalCode: 43, label: "Eritrea" },
  { ISO2: "EE", internalCode: 44, label: "Estland" },
  { ISO2: "FJ", internalCode: 45, label: "Fidschi" },
  { ISO2: "FI", internalCode: 46, label: "Finnland" },
  { ISO2: "FM", internalCode: 47, label: "Föderierte Staaten von Mikronesien" },
  { ISO2: "FR", internalCode: 48, label: "Frankreich" },
  { ISO2: "GA", internalCode: 49, label: "Gabun" },
  { ISO2: "GM", internalCode: 50, label: "Gambia" },
  { ISO2: "GE", internalCode: 51, label: "Georgien" },
  { ISO2: "GH", internalCode: 52, label: "Ghana" },
  { ISO2: "GD", internalCode: 53, label: "Grenada" },
  { ISO2: "GR", internalCode: 54, label: "Griechenland" },
  { ISO2: "GB", internalCode: 55, label: "Großbritannien" },
  { ISO2: "GT", internalCode: 56, label: "Guatemala" },
  { ISO2: "GN", internalCode: 57, label: "Guinea" },
  { ISO2: "GW", internalCode: 58, label: "Guinea-Bissau" },
  { ISO2: "GY", internalCode: 59, label: "Guyana" },
  { ISO2: "HT", internalCode: 60, label: "Haiti" },
  { ISO2: "HN", internalCode: 61, label: "Honduras" },
  { ISO2: "IN", internalCode: 62, label: "Indien" },
  { ISO2: "ID", internalCode: 63, label: "Indonesien" },
  { ISO2: "IQ", internalCode: 64, label: "Irak" },
  { ISO2: "IR", internalCode: 65, label: "Iran" },
  { ISO2: "IE", internalCode: 66, label: "Irland" },
  { ISO2: "IS", internalCode: 67, label: "Island" },
  { ISO2: "IL", internalCode: 68, label: "Israel" },
  { ISO2: "IT", internalCode: 69, label: "Italien" },
  { ISO2: "JM", internalCode: 70, label: "Jamaika" },
  { ISO2: "JP", internalCode: 71, label: "Japan" },
  { ISO2: "YE", internalCode: 72, label: "Jemen" },
  { ISO2: "JO", internalCode: 73, label: "Jordanien" },
  { ISO2: "KH", internalCode: 74, label: "Kambodscha" },
  { ISO2: "CM", internalCode: 75, label: "Kamerun" },
  { ISO2: "CA", internalCode: 76, label: "Kanada" },
  { ISO2: "CB", internalCode: 77, label: "Kap Verde" },
  { ISO2: "KZ", internalCode: 78, label: "Kasachstan" },
  { ISO2: "QA", internalCode: 79, label: "Katar" },
  { ISO2: "KE", internalCode: 80, label: "Kenia" },
  { ISO2: "KG", internalCode: 81, label: "Kirgisistan" },
  { ISO2: "KI", internalCode: 82, label: "Kiribati" },
  { ISO2: "CO", internalCode: 83, label: "Kolumbien" },
  { ISO2: "KM", internalCode: 84, label: "Komoren" },
  { ISO2: "CD", internalCode: 85, label: "Kongo, Demokratische Republik" },
  { ISO2: "HR", internalCode: 86, label: "Kroatien" },
  { ISO2: "CU", internalCode: 87, label: "Kuba" },
  { ISO2: "KW", internalCode: 88, label: "Kuwait" },
  { ISO2: "LA", internalCode: 89, label: "Laos" },
  { ISO2: "LS", internalCode: 90, label: "Lesotho" },
  { ISO2: "LV", internalCode: 91, label: "Lettland" },
  { ISO2: "LB", internalCode: 92, label: "Libanon" },
  { ISO2: "LR", internalCode: 93, label: "LIBERIA" },
  { ISO2: "LY", internalCode: 94, label: "Libysch-Arabische Dschamahirija" },
  { ISO2: "LI", internalCode: 95, label: "Liechtenstein" },
  { ISO2: "LT", internalCode: 96, label: "Litauen" },
  { ISO2: "LU", internalCode: 97, label: "Luxemburg" },
  { ISO2: "MG", internalCode: 98, label: "Madagaskar" },
  { ISO2: "MW", internalCode: 99, label: "Malawi" },
  { ISO2: "MY", internalCode: 100, label: "Malaysia" },
  { ISO2: "MV", internalCode: 101, label: "Malediven" },
  { ISO2: "ML", internalCode: 102, label: "Mali" },
  { ISO2: "MT", internalCode: 103, label: "Malta" },
  { ISO2: "MA", internalCode: 104, label: "Marokko" },
  { ISO2: "MH", internalCode: 105, label: "Marshall-Inseln" },
  { ISO2: "MR", internalCode: 106, label: "Mauretanien" },
  { ISO2: "MU", internalCode: 107, label: "Mauritius" },
  { ISO2: "MK", internalCode: 108, label: "Mazedonien" },
  { ISO2: "MX", internalCode: 109, label: "Mexiko" },
  { ISO2: "MD", internalCode: 110, label: "Moldawien" },
  { ISO2: "MC", internalCode: 111, label: "Monaco" },
  { ISO2: "MN", internalCode: 112, label: "Mongolei" },
  { ISO2: "ME", internalCode: 113, label: "Montenegro" },
  { ISO2: "MZ", internalCode: 114, label: "Mosambik" },
  { ISO2: "MM", internalCode: 115, label: "Myanmar" },
  { ISO2: "NA", internalCode: 116, label: "Namibia" },
  { ISO2: "NR", internalCode: 117, label: "Nauru" },
  { ISO2: "NP", internalCode: 118, label: "Nepal" },
  { ISO2: "NZ", internalCode: 119, label: "Neuseeland" },
  { ISO2: "NI", internalCode: 120, label: "Nicaragua" },
  { ISO2: "NL", internalCode: 121, label: "Niederlande" },
  { ISO2: "NE", internalCode: 122, label: "Niger" },
  { ISO2: "NG", internalCode: 123, label: "Nigeria" },
  { ISO2: "NU", internalCode: 124, label: "Niue" },
  { ISO2: "KP", internalCode: 125, label: "Nordkorea" },
  { ISO2: "NO", internalCode: 126, label: "Norwegen" },
  { ISO2: "OM", internalCode: 127, label: "Oman" },
  { ISO2: "AT", internalCode: 128, label: "Österreich" },
  { ISO2: "PK", internalCode: 129, label: "Pakistan" },
  { ISO2: "PW", internalCode: 130, label: "Palau" },
  { ISO2: "PA", internalCode: 131, label: "Panama" },
  { ISO2: "PG", internalCode: 132, label: "Papua-Neuguinea" },
  { ISO2: "PY", internalCode: 133, label: "Paraguay" },
  { ISO2: "PE", internalCode: 134, label: "Peru" },
  { ISO2: "PH", internalCode: 135, label: "Philippinen" },
  { ISO2: "PL", internalCode: 136, label: "Polen" },
  { ISO2: "PT", internalCode: 137, label: "Portugal" },
  { ISO2: "CG", internalCode: 138, label: "Republik Kongo" },
  { ISO2: "RW", internalCode: 139, label: "Ruanda" },
  { ISO2: "RO", internalCode: 140, label: "Rumänien" },
  { ISO2: "RU", internalCode: 141, label: "Russland" },
  { ISO2: "SB", internalCode: 142, label: "Salomonen" },
  { ISO2: "ZM", internalCode: 143, label: "Sambia" },
  { ISO2: "WS", internalCode: 144, label: "Samoa" },
  { ISO2: "SM", internalCode: 145, label: "San Marino" },
  { ISO2: "ST", internalCode: 146, label: "São Tomé und Príncipe" },
  { ISO2: "SA", internalCode: 147, label: "Saudi-Arabien" },
  { ISO2: "SE", internalCode: 148, label: "Schweden" },
  { ISO2: "CH", internalCode: 149, label: "Schweiz" },
  { ISO2: "SN", internalCode: 150, label: "Senegal" },
  { ISO2: "RS", internalCode: 151, label: "Serbien" },
  { ISO2: "SC", internalCode: 152, label: "Seychellen" },
  { ISO2: "SL", internalCode: 153, label: "Sierra Leone" },
  { ISO2: "ZW", internalCode: 154, label: "Simbabwe" },
  { ISO2: "SG", internalCode: 155, label: "Singapur" },
  { ISO2: "SK", internalCode: 156, label: "Slowakei" },
  { ISO2: "SI", internalCode: 157, label: "Slowenien" },
  { ISO2: "SO", internalCode: 158, label: "Somalia" },
  { ISO2: "ES", internalCode: 159, label: "Spanien" },
  { ISO2: "LK", internalCode: 160, label: "Sri Lanka" },
  { ISO2: "KN", internalCode: 161, label: "St. Kitts und Nevis" },
  { ISO2: "LC", internalCode: 162, label: "St. Lucia" },
  { ISO2: "VC", internalCode: 163, label: "St. Vincent und die Grenadinen" },
  { ISO2: "ZA", internalCode: 164, label: "Südafrika" },
  { ISO2: "SD", internalCode: 165, label: "Sudan" },
  { ISO2: "KR", internalCode: 166, label: "Südkorea" },
  { ISO2: "SR", internalCode: 167, label: "Surinam" },
  { ISO2: "SZ", internalCode: 168, label: "Eswatini" },
  { ISO2: "SY", internalCode: 169, label: "Syrien" },
  { ISO2: "TJ", internalCode: 170, label: "Tadschikistan" },
  { ISO2: "TZ", internalCode: 171, label: "Tansania" },
  { ISO2: "TH", internalCode: 172, label: "Thailand" },
  { ISO2: "TL", internalCode: 173, label: "Timor-Leste" },
  { ISO2: "TG", internalCode: 174, label: "Togo" },
  { ISO2: "TO", internalCode: 175, label: "Tonga" },
  { ISO2: "TT", internalCode: 176, label: "Trinidad und Tobago" },
  { ISO2: "TD", internalCode: 177, label: "Tschad" },
  { ISO2: "CZ", internalCode: 178, label: "Tschechische Republik" },
  { ISO2: "TN", internalCode: 179, label: "Tunesien" },
  { ISO2: "TR", internalCode: 180, label: "Türkei" },
  { ISO2: "TM", internalCode: 181, label: "Turkmenistan" },
  { ISO2: "TV", internalCode: 182, label: "Tuvalu" },
  { ISO2: "UG", internalCode: 183, label: "Uganda" },
  { ISO2: "UA", internalCode: 184, label: "Ukraine" },
  { ISO2: "HU", internalCode: 185, label: "Ungarn" },
  { ISO2: "UY", internalCode: 186, label: "Uruguay" },
  { ISO2: "US", internalCode: 187, label: "USA" },
  { ISO2: "UZ", internalCode: 188, label: "Usbekistan" },
  { ISO2: "VU", internalCode: 189, label: "Vanuatu" },
  { ISO2: "VA", internalCode: 190, label: "Vatikanstadt" },
  { ISO2: "VE", internalCode: 191, label: "Venezuela" },
  { ISO2: "AE", internalCode: 192, label: "Vereinigte Arabische Emirate" },
  { ISO2: "VN", internalCode: 193, label: "Vietnam" },
  { ISO2: "CF", internalCode: 194, label: "Zentralafrikanische Republik" },
  { ISO2: "CY", internalCode: 195, label: "Zypern" },
  { ISO2: "RS-KM", internalCode: 196, label: "Kosovo" },
  { ISO2: "NONE", internalCode: 197, label: "Staatenlos" }
];
